import { useFormContext, useWatch } from 'react-hook-form';
import { useCallback, useEffect } from 'react';
import { CurrencyInputV2, DocumentNumberFieldV2, FormFieldV2 } from '@/components/custom/erp';
import { FormFieldActions, FormFieldState } from '../../hooks';
import { Label } from '@/components/ui/label';
import { MA_CHUNG_TU } from '@/constants';
import { FormMode } from '@/types/form';

interface BasicInfoTabProps {
  formMode: FormMode;
  formState: {
    state: FormFieldState;
    actions: FormFieldActions;
  };
}

export function BasicInfoTab({ formMode, formState: { state, actions } }: BasicInfoTabProps) {
  const { setValue } = useFormContext();
  const ngay_ct = useWatch({ name: 'ngay_ct' });

  useEffect(() => {
    if (ngay_ct) {
      setValue('ngay_lct', ngay_ct);
    }
  }, [ngay_ct, setValue]);
  return (
    <div className='flex flex-col gap-3 p-4'>
      <div className='grid grid-cols-12 gap-6'>
        <div className='col-span-9 space-y-4'>
          <div className='flex items-center'>
            <DocumentNumberFieldV2
              ma_ct={MA_CHUNG_TU.BAN_HANG.CHUNG_TU_PHAI_THU_KHAC}
              quyenChungTu={state.quyenChungTu}
              onQuyenChungTuChange={actions.setQuyenChungTu}
              soChungTu={state.soChungTu}
              onSoChungTuChange={actions.setSoChungTu}
              disabled={formMode === 'view'}
              classNameSearchField='w-full'
              labelClassName='w-[150px]'
              formMode={formMode}
            />
          </div>

          <div className='flex items-center'>
            <Label className='w-[150px]'>Ngày chứng từ</Label>
            <FormFieldV2 name='ngay_ct' type='date' disabled={formMode === 'view'} labelClassName='w-32 shrink-0' />
          </div>

          <div className='flex items-center'>
            <Label className='w-[150px]'>Diễn giải</Label>
            <div className='flex-1'>
              <FormFieldV2
                name='dien_giai'
                type='text'
                value={state.dienGiai}
                onValueChange={e => actions.setDienGiai(e)}
                disabled={formMode === 'view'}
                labelClassName='w-48'
                className='w-full'
              />
            </div>
          </div>
        </div>

        <div className='col-span-3 space-y-4'>
          <div className='flex'>
            <CurrencyInputV2 formMode={formMode} />
          </div>

          <FormFieldV2
            name='status'
            type='select'
            disabled={formMode === 'view'}
            label='Trạng thái'
            labelClassName='w-32 shrink-0'
            fieldClassName='w-full'
            options={[
              { value: '0', label: 'Lập chứng từ' },
              { value: '3', label: 'Chờ duyệt' },
              { value: '5', label: 'Xuất hóa đơn' },
              { value: '7', label: 'Bỏ duyệt đơn hàng' }
            ]}
          />

          <FormFieldV2
            label='Dữ liệu nhận được'
            name='transfer_yn'
            type='checkbox'
            disabled={true}
            labelClassName='w-32'
          />
        </div>
      </div>
    </div>
  );
}
